import Styled from 'styled-components'

export const AlignRadio = Styled.div`
display: flex;
align-items: center;
`

export const Radio = Styled.input`
cursor: pointer;
appearance: none;
border: 2px solid var(--primary-color);
width: 24px;
height: 24px;
border-radius: 50%;
position: relative;
display:flex;
align-items: center;
justify-content: center;


&:before {
    content: "";
    position: absolute;
    width: 12px;
    height: 12px;
    background: var(--primary-color); 
    border-radius: 50%;
    opacity: 0;
}
&:checked:before {
    opacity: 1;
}

@media(max-width: 800px) {
    width: 24px;
    height: 24px;

    &:before {
        width: 12px;
        height: 12px;
    }
}
`